import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, sub, center = true }) => (
  <div className={center ? "max-w-2xl mx-auto text-center" : "max-w-2xl"}>
    <Reveal>
      <span className="text-xs font-semibold uppercase tracking-[0.2em] text-violet-700">{eyebrow}</span>
    </Reveal>
    <Reveal delay={0.06}>
      <h2 className="font-display mt-3 text-3xl sm:text-4xl font-bold tracking-tight leading-[1.15] text-[#3B0764]">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.12}>
        <p className="mt-4 text-base sm:text-lg leading-relaxed text-[#6B5CA5]">{sub}</p>
      </Reveal>
    )}
  </div>
);
